import React from "react";
import { Header } from "semantic-ui-react";

interface IPrintWorkflows {
  workflowSteps: any;
  permitsEmployees: any;
}

export const PrintWorkflows = ({ workflowSteps, permitsEmployees }: IPrintWorkflows) => {
  return (
    <>
      <Header content='Workflow' style={{ marginTop: 8, fontSize: 16 }} />
      {workflowSteps?.map((item: any, index: number) => {
        const { status, title } = item?.data.attributes;
        const currentAssignee = permitsEmployees.find(
          (employee: any) => employee.id == item.data.attributes["assignee-id"],
        );
        const firstName = currentAssignee?.attributes["first-name"];
        const lastName = currentAssignee?.attributes["last-name"];
        const assigneeName = `${firstName} ${lastName}`;
        return (
          <div key={index} style={{ marginBottom: 8 }}>
            <Header
              as='h4'
              content={`${index + 1}. ${title} - ${status.toUpperCase()}`}
              subheader={`Assignee: ${assigneeName}`}
            />
          </div>
        );
      })}
    </>
  );
};

export default PrintWorkflows;
